import { QueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: (failureCount, error) => {
        if (error instanceof AxiosError && error.response?.status === 404) {
          if (failureCount >= 1) {
            // only need to retry 404 once
            return false;
          }
        }
        if (failureCount >= 3) {
          return false;
        }
        return true;
      },
    },
  },
});
